<template>
  <p>Super <span class="member"><MemberName :members="members" :id="player" /></span> vous avez pioché <span class="member"><MemberName :members="members" :id="drawResult" /></span>&#8239;!</p>
  <p v-if="drawEnd">
    Tout les joueurs ont pioché, la partie est maintenant terminée.
  </p>
  <p v-if="drawEnd">
    Si vous souhaitez commencer une autre partie avec de nouvelles personnes.
    <br/><button @click="pageReload()">cliquez ici</button> pour revenir à l'accueil.
  </p>
  <p v-else>
    C'est maintenant à <span class="member"><MemberName :members="members" :id="next.id" /></span> de tirer au sort. Envoyez-lui
    <button @click="copyLink()">ce lien</button> pour qu'elle•il participe.
  </p>
</template>

<script>

// VUE COMPONENTS IMPORTS

import MemberName from "@/components/MemberName.vue";

// EXPORTS

export default {
  components: {
    MemberName,
  },
  emits: [
    "copyLink",
    "copy-link",
  ],
  props: {
    members: {
      type: Array,
      required: true,
    },
    drawResult: {
      type: String,
      required: true,
    },
    player: {
      type: String,
      required: true,
    },
    drawEnd: {
      type: Boolean,
      required: true,
    },
    next: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const pageReload = () => {
        document.location.reload();
    };
    const copyLink = (data) => {
      emit("copy-link", data);
    };

    return {
      pageReload,
      copyLink,
    };
  },
};
</script>

<style>
</style>